export class UserProfile {
  readonly idKeycloak: string;
  username: string;
  roles: string[];
  groups: UserGroup[];
  firstName?: string;
  lastName?: string;
  email?: string;

  constructor(idKeycloak: string, username: string, roles: string[], firstName?: string, lastName?: string, email?: string) {
    this.username = username;
    this.roles = roles;
    this.idKeycloak = idKeycloak;
    this.firstName = firstName || undefined;
    this.lastName = lastName || undefined;
    this.email = email || undefined;
  }

  getDisplayName(): string {
    const full = [this.firstName, this.lastName].filter(Boolean).join(' ');
    return full || this.username;
  }

  hasFullName(): boolean {
    return !!(this.firstName || this.lastName);
  }

  isService(): boolean {
    return this.roles.indexOf('SERVICE') > -1;
  }

  isAdmin(): boolean {
    return this.roles.indexOf('ADMIN') > -1;
  }

  isMPK(): boolean {
    return this.roles.indexOf('MPK') > -1;
  }

  hasGSMPrivilege(): boolean {
    return this.roles.indexOf('MPK_GSM_PRIVILEGE') > -1;
  }
}

export class UserGroup {
  groupId: number;
  name: string;
}
